import { Container, Grid, useTheme } from "@mui/material";
import { useEffect, useState } from "react";

import BackButton from "components/BackButton";
import BoxReferralHistory from "./Component/BoxReferralHistory";
import DetailsReferralModal from "./Component/DetailsReferralModal";
import EmptyState from "components/EmptyState";
import { EmptyStateIcon } from "assets/Icon";
import { GetReferralIsPaidList } from "store/api/referral";
import Modal from "components/Modal";
import Pagination from "components/Pagination";
import TableReferralHistory from "./Component/TableReferralHistory";
import TableSkeleton from "components/Skeletons/Table.skeleton";
import http from "config/http";
import useIsMobileView from "hooks/useIsMobileView";
import useNotify from "hooks/useNotify";
import { useSearchParams } from "react-router-dom";

function ReferralHistory() {
  const theme = useTheme();
  const [loading, setLoading] = useState(false);
  const [referralIsPaidList, setReferralIsPaidList] = useState();
  const [detailsReferral, setDetailsReferral] = useState();
  const [openDetailsReferralModal, setOpenDetailsReferralModal] =
    useState(false);
  const notify = useNotify();
  const [searchParams] = useSearchParams();
  const pageNumber = +searchParams.get("page") || 1;
  const pageSize = +searchParams.get("perPage") || 10;
  const isMobileView = useIsMobileView();

  const getReferralIsPaidList = async ({ pageSize, pageNumber }) => {
    try {
      setLoading(true);
      const { data } = await http.get(
        GetReferralIsPaidList({ pageSize, pageNumber })
      );
      setReferralIsPaidList(data);
      setLoading(false);
    } catch (error) {
      notify(error?.response?.data?.message, "error");
    }
  };

  const handleChangePaginate = ({ page, perPage }) => {
    getReferralIsPaidList({ pageNumber: page, pageSize: perPage });
  };

  useEffect(() => {
    getReferralIsPaidList({ pageSize, pageNumber });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Container maxWidth="100%">
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <BackButton text="Referral History" to="/referral" />
          </Grid>

          {isMobileView ? (
            <>
              {referralIsPaidList?.totalPages !== 0 ? (
                <>
                  {" "}
                  {referralIsPaidList?.data?.map((referralItem) => (
                    <Grid item xs={12}>
                      <BoxReferralHistory referralItem={referralItem} />
                    </Grid>
                  ))}
                </>
              ) : (
                <EmptyState
                  text={"No Referral"}
                  icon={<EmptyStateIcon color={theme.palette.modules.border} />}
                />
              )}

              <Grid item xs={12}>
                <Pagination
                  count={referralIsPaidList?.totalPages}
                  perPage={referralIsPaidList?.pageSize}
                  onChange={handleChangePaginate}
                />
              </Grid>
            </>
          ) : (
            <>
              {!loading ? (
                <TableReferralHistory
                  referralIsPaidList={referralIsPaidList}
                  getReferralIsPaidList={getReferralIsPaidList}
                  setDetailsReferral={setDetailsReferral}
                  setOpenDetailsReferralModal={setOpenDetailsReferralModal}
                />
              ) : (
                <TableSkeleton />
              )}
            </>
          )}
        </Grid>
      </Container>

      <Modal
        dir="ltr"
        title="Referral Details"
        maxWidth="xs"
        open={openDetailsReferralModal}
        onClose={() => setOpenDetailsReferralModal(false)}
      >
        <DetailsReferralModal detailsReferral={detailsReferral} />
      </Modal>
    </>
  );
}

export default ReferralHistory;
